import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 13 11"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 10.9h3.5L5 8.8c.4-.7.8-1.3 1.2-1.9h.1c.4.7 1 1.2 1.5 1.9l1.7 2.1H13L8.5 5.5 12.8 0H9.3L8 2 6.8 3.8h-.1c-.4-.6-.9-1.1-1.2-1.8L3.9 0H.3l4.1 5.3z",
  style: {"fill":"currentColor"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }